module.exports = __webpack_public_path__ + "img/benefit-08-dialogs.51b1c191.png";